import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_database",
  "use": "icon-project_database-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_database\"><g transform=\"translate(3 2)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><ellipse cx=\"11\" cy=\"5\" rx=\"10\" ry=\"4\" /><path d=\"M1 12c0 2.21 4.477 4 10 4s10-1.79 10-4M1 19c0 2.21 4.477 4 10 4s10-1.79 10-4\" /><path stroke-linecap=\"round\" d=\"M21 19V5M1 19V5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol